import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const WebviewLoader = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const externalUrl = location.state?.externalUrl;

    useEffect(() => {
        if (!externalUrl) {
            // If no URL is provided in state, navigate back home
            navigate('/', { replace: true });
        }
        
        // The most robust way for external URLs is the Capacitor Browser plugin:
        import('@capacitor/browser').then(({ Browser }) => {
            if (Browser) {
                // Open the external URL in an in-app browser that respects the app context
                Browser.open({ url: externalUrl, presentationStyle: 'fullscreen' });
                // Immediately navigate back to the previous page/Home, as the browser will overlay
                navigate('/', { replace: true });
            } else {
                // Fallback for web/unsupported
                window.open(externalUrl, '_blank');
                navigate('/', { replace: true });
            }
        }).catch(err => {
            console.error("Capacitor Browser not available:", err);
            window.open(externalUrl, '_blank');
            navigate('/', { replace: true });
        });

    }, [externalUrl, navigate]);

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Loading External News...</h2>
            <p>Please wait while the external news link loads in the in-app browser.</p>
        </div>
    );
};

export default WebviewLoader;